import { formAnatomy as o } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers as t, cssVar as l, defineStyle as r } from "@chakra-ui/styled-system";
const { definePartsStyle: i, defineMultiStyleConfig: a } = t(o.keys), e = l("form-control-color"), n = r({
  marginStart: "1",
  [e.variable]: "colors.red.500",
  _dark: {
    [e.variable]: "colors.red.300"
  },
  color: e.reference
}), c = r({
  [e.variable]: "colors.coldAlpha.700",
  _dark: {
    [e.variable]: "colors.whiteAlpha.600"
  },
  color: e.reference,
  lineHeight: "5",
  fontSize: "sm"
}), s = i({
  container: {
    width: "100%",
    position: "relative"
  },
  requiredIndicator: n,
  helperText: c
}), m = a({
  baseStyle: s
});
export {
  m as formTheme
};
